const isSameTypeData = (a, b) => Object.prototype.toString.call(a) === Object.prototype.toString.call(b); // 两个类型完全相同
const isArray = (val) => Object.prototype.toString.call(val) === '[object Array]';
const isFullArray = (val) => isArray(val) && val.length;
const isObject = (val) => Object.prototype.toString.call(val) === '[object Object]';
const isString = (val) => Object.prototype.toString.call(val) === '[object String]';
const isUndefined = (val) => Object.prototype.toString.call(val) === '[object Undefined]';

export const handleUndefinedDoCommon = (res, defaultData) => {
  if (!isSameTypeData(res, defaultData)) {
    // 类型不同 分两种情况
    if (isUndefined(defaultData)) {
      //防止前端误传  前端没传默认值
      return res;
    }
    // 兼容处理 防止传错值
    if (isObject(res) || isArray(res)) {
      return res;
    }
    return defaultData;
  }
  if (isObject(res)) {
    // eslint-disable-next-line new-cap, no-use-before-define
    return formatObjectResData(res, defaultData);
  }
  if (isArray(res)) {
    // eslint-disable-next-line new-cap, no-use-before-define
    return formatArrayResData(res, defaultData);
  }
  if (isString(res)) {
    return res || defaultData;
  }
  return res;
};

const formatArrayResData = (res, defaultData) => {
  if (!isFullArray(res) || !isFullArray(defaultData)) {
    //  空数组
    return res;
  }
  return res.map((item, index) => handleUndefinedDoCommon(item, defaultData[index]));
};
const formatObjectResData = (res, defaultData) => {
  const resKeys = Object.keys(res);
  const defaultDataKeys = Object.keys(defaultData);
  defaultDataKeys.forEach((key) => {
    // 拿出key 循环
    if (!resKeys.includes(key)) {
      res[key] = defaultData[key]; // res 少某些key 补全
    } else {
      res[key] = handleUndefinedDoCommon(res[key], defaultData[key]);
    }
  });
  return res;
};

// test：

// const defaultData = {
//     country: 0,
//     epProStrategy: {
//         strategy: 0,
//         sdfddgf: 0,
//     },
//     hikIdStrategy: {
//         strategy: 0,
//         sdfddgf: {
//             dfdf:0,
//             dfdfdfrgtrh:{
//                 hedufjihi:0,
//                 eruig3yu3ty:0,
//                 dfer:{
//                     hiuoh:0
//                 }
//             }
//         },
//     },
//     showEP: false,
//     showEpWord: false,
// }

// const resData = {
//     country: 1,
//     epProStrategy: {
//         strategy: 3,
//         sdfddgf: 56,
//     },
//     showEP: true,
//     showEpWord: true,
// }

//  输出
//{
//     country: 1,
//     epProStrategy: {
//         strategy: 3,
//         sdfddgf: 56,
//     },
//     hikIdStrategy: {
//         strategy: 0,
//         sdfddgf: {
//             dfdf:0,
//             dfdfdfrgtrh:{
//                 hedufjihi:0,
//                 eruig3yu3ty:0,
//                 dfer:{
//                     hiuoh:0
//                 }
//             }
//         },
//     },
//     showEP: true,
//     showEpWord: true,
// }

// ------------------分割线----------

// let resData = [
//     {
//       name: "zhangsan",
//       age: 20,
//       child: [{ name: "xiaoming" }],
//       child1: [{ name: "xiaowang" }],
//       child3: [{ name: "xiaoli" }],
//     },
//   ];

//   let defaultData = [
//     {
//       name: "",
//       age: 0,
//       child: [{ name: "" }],
//       child1: [{ name: "" }],
//       child3: [{ name: "" }],
//       child4: [{ name: "" },{age:0}],
//     },
//   ];
// 输出
//   {
//       name: "zhangsan",
//       age: 20,
//       child: [{ name: "xiaoming" }],
//       child1: [{ name: "xiaowang" }],
//       child3: [{ name: "xiaoli" }],
//       child4: [{ name: "" },{age:0}],
//     },
